import { createPinia } from 'pinia'
import piniaPersist from 'pinia-plugin-persist'

export { default as useLoginStore } from './loginStore'
export type { LoginStore } from './loginStore'
export { default as useDialogStore } from './dialogStore'

const store = createPinia()
store.use(piniaPersist)

export default store
